import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import EpiContext from '@episerver/spa-core/Spa';
import {closePopUpOnTrackerInit} from '../../../SelfCareSlice';
import {onTrackerInitPopupEnum} from './trackerEnum';

const TrackerInitPopUp = (props) => {
  const [popUpData, setPopUpData] = useState(getPopupData());

  function getPopupData() {
    return onTrackerInitPopupEnum[props.selfCareSlice.selfCareData.popupReasonOnTrackerInit];
  }

  const submitButtonClick = () => {
    switch (popUpData?.buttonAction) {
      case 'debtPayment':
        EpiContext.navigateTo(props.epiData?.payDebtLink?.value);
        props.closePopUpOnTrackerInit();
        break;
      case 'updatePaymentMethod':
        EpiContext.navigateTo(props.epiData?.updatePaymentMethodLink?.value);
        props.closePopUpOnTrackerInit();
        break;
      default:
        break;
    }
  };
  return (
    <div className='messagePopup'>
      <Image className='popup-icon' src={popUpData?.icon} />
      <div className='l-title' dangerouslySetInnerHTML={{__html: popUpData?.title}} />
      <div className='m-title' dangerouslySetInnerHTML={{__html: popUpData?.description}} />

      <div className='button-container'>
        <BtnSubmit text={popUpData?.buttonText} onclick={() => submitButtonClick()} />
      </div>
    </div>
  );
};

const mapDispatchToProps = {closePopUpOnTrackerInit};
const mapStateToProps = (state) => ({
  selfCareSlice: state.selfcarePage,
});
export default connect(mapStateToProps, mapDispatchToProps)(TrackerInitPopUp);
